import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { useAuthStore } from '@/store/auth';

type Access = { create: boolean; update: boolean; delete: boolean };
export function usePromotionAccess(resource: 'coupons' | 'announcements'): Access {
  const user = useAuthStore((s) => s.user);
  const { data } = useQuery({
    queryKey: ['promotion-access', user?._id, user?.role, user?.permissions],
    queryFn: async () =>
      (
        await api
          .get('admin/promotion-access')
          .json<{ data: { coupons: Access; announcements: Access } }>()
      ).data,
    enabled: !!user,
    retry: false,
    staleTime: 0,
  });
  return data?.[resource] ?? { create: false, update: false, delete: false };
}
